import { LoanService } from '@/utils/service'

const caller = () => {
    let ua = window.navigator.userAgent.toLowerCase();
    let device = 'Touch'
    if (ua.indexOf('iphone'.toLowerCase()) > -1 ||
        ua.indexOf('ipad'.toLowerCase()) > -1 ||
        ua.indexOf('ipod'.toLowerCase()) > -1) {
        device = 'IOS';
    }
    if (ua.indexOf('android'.toLowerCase()) > -1) {
        device = 'Android';
    }
    if (ua.indexOf('micromessenger') > -1) {
        device = 'WeChat';
    }
    let map = {
        Web: 0,
        Android: 1,
        IOS: 2,
        Touch: 3,
        Auto: 4,
        WeChat: 5,
        JmAppAndroid: 11,
        JmAppIOS: 12,
        DmAppAndroid: 13,
        DmAppIOS: 14,
        JimuDaikuan: 20,
        HzAppIOS: 15,
        HzAppAndroid: 16,
        Dm2AppIOS: 17
    }
    return map[device]
}

/**
 * 被拒导流路由
 * @param params.userId 用户ID
 * @returns
 * applyId 申请ID
 * applyStatus 申请状态  APPLY_DL_STATUS
 */
export const rejectRoute = (params = {
    userId: 0,
    position: '0,0'
}) => {
    return new LoanService({
        url: '/loan/app/user/v6/reject/route',
        method: 'get',
        data: {
            userId: params.userId,
            position: params.position,
            caller: caller()
        }
    })
}

/**
 * 获取补充信息
 * @param params.userId 用户ID
 * @param params.applyId 申请ID
 * @returns
 * applyId 申请ID
 * userId 用户ID
 * education 学历
 * nContractor 联系人姓名
 * nMobile 联系人手机号
 * nRelationship 联系人关系
 * nContractor2 联系人2姓名
 * nMobile2 联系人2手机号
 * nRelationship2 联系人2关系
 */
export const getExtData = (params = {
    applyId: 0,
    userId: 0
}) => {
    return new LoanService({
        url: '/loan/app/user/v6/get/ext/data',
        method: 'get',
        data: {
            userId: params.userId,
            applyId: params.applyId
        }
    })
}

/**
 * 提交补充信息
 * @param params.userId 用户ID
 * @param params.applyId 申请ID
 * @param params.nContractor2 联系人姓名2
 * @param params.nMobile2 联系人电话2
 * @param params.nRelationship2 和联系人关系2
 * @param params.maritalStatus 婚姻状态
 * @param params.purpose 借款用途
 * @param params.education 学历
 * @returns
 * applyId 申请ID
 * applyStatus 申请状态
 */
export const submitExtData = (params = {
    applyId: 0,
    userId: 0,
    education: 0,
    purpose: 0,
    maritalStatus: 0,
    nContractor2: '',
    nMobile2: '',
    nRelationship2: 0
}) => {
    return new LoanService({
        url: '/loan/app/user/v6/set/ext/data',
        method: 'post',
        data: params
    })
}

/**
 * 身份照片上传验证
 * @param {*} params.applyId 申请ID
 * @param {*} params.userId 用户ID
 * @param {*} params.fileType 类型1正面2反面
 * @param {*} params.file 文件
 */
export const uploadPhotoFile = (params = {
    applyId: 0,
    userId: 0,
    fileType: 1,
    file: ''
}) => {
    return new LoanService({
        url: '/loan/app/user/v6/photo/upload',
        method: 'post',
        transformRequest: [function(data, headers) {
            headers['Content-Type'] = 'multipart/form-data'

            let formData = new FormData();
            formData.append('applyId', params.applyId);
            formData.append('userId', params.userId);
            formData.append('fileType', params.fileType);
            formData.append('file', params.file);
            return formData
        }]
    })
}

/**
 * 身份证上传结果
 * @param params.userId 用户ID
 * @param params.applyId 申请ID
 * @returns
 * applyId 申请ID
 * applyStatus 申请状态
 */
export const photoVerify = (params = {
    applyId: 0,
    userId: 0
}) => {
    return new LoanService({
        url: '/loan/app/user/v6/get/check/result',
        method: 'get',
        data: params
    })
}


/**
 * 手持上传
 * @param {*} params.applyId 申请ID
 * @param {*} params.userId 用户ID
 * @param {*} params.file 文件
 * @returns
 * applyId 申请ID
 * applyStatus 申请状态
 */
export const uploadFaceFile = (params = {
    applyId: 0,
    userId: 0,
    file: ''
}) => {
    return new LoanService({
        url: '/loan/app/user/v6/photo/face/verify',
        method: 'post',
        transformRequest: [function(data, headers) {
            headers['Content-Type'] = 'multipart/form-data'

            let formData = new FormData();
            formData.append('applyId', params.applyId);
            formData.append('userId', params.userId);
            formData.append('file', params.file);
            return formData
        }]
    })
}

/**
 * 绑卡短信
 * @param {*} params 
 */
export const sendBankSms = (params = {
    applyId: 0,
    userId: 0,
    cardId: '',
    cardNo: '',
    bankNo: '',
    mobile: ''
}) => {
    return new LoanService({
        url: '/loan/app/pmt/v5/card/bind',
        method: 'get',
        data: params
    })
}

/**
 * 绑卡
 * @param {*} params
 */
export const bindBank = (params = {
    applyId: 0,
    userId: 0,
    cardId: '',
    cardNo: '',
    bankNo: '',
    mobile: ''
}) => {
    return new LoanService({
        url: '/loan/app/pmt/v5/card/bind',
        method: 'post',
        data: params
    })
}

export const getApplyProcess = (params = {
    applyId: 0,
    userId: 0
}) => {
    return new LoanService({
        url: '/loan/app/user/v6/get/apply/status',
        method: 'get',
        data: params
    })
}

/**
 * 获取签约信息
 * @param params.userId 用户ID
 * @param params.applyId 申请ID
 * @returns
 * applyBalance	BigDecimal	否	借款金额
 * applyDays	Integer	否	借款期限
 */
export const getSignInfo = (params = {
    applyId: 0,
    userId: 0
}) => {
    return new LoanService({
        url: '/loan/app/user/v6/loan/detail',
        method: 'get',
        data: params
    })
}

/**
 * 签约
 * @param {*} params 
 */
export const sign = (params = {
    applyId: 0,
    userId: 0
}) => {
    return new LoanService({
        url: '/loan/app/user/v6/loan/sign',
        method: 'post',
        data: params
    })
}

export const getPlanList = (params = {
    applyId: 0,
    userId: 0
}) => {
    return new LoanService({
        url: '/loan/app/user/v6/preview/repayment/schedule',
        method: 'get',
        data: params
    })
}
export const loanConfirm = (params = {
    applyBalance: 0,
    applyDays: 0
}) => {
    return new LoanService({
        url: '/loan/app/user/v6/loan',
        method: 'post',
        data: params
    })
}

/**
 * 获取小赢易贷话单地址
 * @param {*} params
 */
export const getMobileUrlForXiaoYing = (params = {
    applyId: 0,
    userId: 0,
    redirectUrl: ''
}) => {
    return new LoanService({
        url: '/loan/app/user/v6/xiaoying/telecom',
        method: 'get',
        data: params
    })
}

/**
 * 获取小赢易贷话单验证结果
 * @param {*} params
 */
export const getMobileVerifyForXiaoYing = (params = {
    applyId: 0,
    userId: 0
}) => {
    return new LoanService({
        url: '/loan/app/user/v6/xiaoying/verify',
        method: 'post',
        data: params
    })
}

/**
 * 获取小赢易贷合同地址
 * @param {*} params
 */
export const getContractForXiaoYing = (params = {
    applyId: 0,
    userId: 0,
    scene: ''
}) => {
    return new LoanService({
        url: '/loan/app/user/v6/xiaoying/contract/url',
        method: 'get',
        data: params
    })
}
